import { render, staticRenderFns } from "./dimensions_selector.vue?vue&type=template&id=53152f84&"
import script from "./dimensions_selector.vue?vue&type=script&lang=js&"
export * from "./dimensions_selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports